import DeliveryGroupItemsList from 'components/SharedComponents/SplitEDD/DeliveryGroupItemsList/DeliveryGroupItemsList';

export default DeliveryGroupItemsList;
